<template>
    <div class="relationship-tech flex flex-col gap-4 rounded border border-solid border-grey-40 bg-white px-6 py-4">

        <div class="flex items-center justify-between gap-4">

            <div class="th-tabs th-tabs-bordered">
                <span class="th-tab th-tab-bordered !text-base " v-for="(item, index) in tabs" :key="index"
                      :class="{ 'th-tab-bordered-active': item.name === activeTab }" @click="() => changeTab(item.name)">
                    {{ item.label }}
                </span>
            </div>

            <button @click="downloadChartAsImage" :disabled="disableUI || graphTechChart?.isEmptyChart" class="th-btn th-btn-plain shrink-0">
                <PtIcon class="th-btn-icon fill-grey-450 text-2xl" icon="SolidExport" />
                <span>{{ t('download') }}</span>
            </button>

        </div>
        <div class="relative flex">
            <div class="relative w-[400px] border-r border-gray-40" v-if="isShowTechTopic">
                <div class="mb-4 text-gray-450">{{ t('mostCitedKeyword') }}:</div>
                <span v-if="isLoadingAllTopic" class="th-loading th-loading-spinner th-loading-lg absolute left-1/2 top-1/2 block -translate-x-1/2 -translate-y-1/2 bg-grey-200"></span>
                <div v-else :class="['flex flex-wrap']">
                    <div v-for="item in techTopicArray" :key="item.id" :class="['mb-2 mr-2 cursor-pointer rounded border px-4 py-1 ', `${item.id === topicId ? ' relationship-tech-topic-selected border-blue-400 bg-blue-50 text-blue-800' :'border-gray-20 bg-gray-20 text-gray-450'}`, { 'pointer-events-none': loadingTopic }]" @click="() => handleTopic(item.id)">
                        <span class=" mr-1">{{ item.name }}</span>
                        <span>({{ item.count }})</span>
                        <span class="icon"></span>
                    </div>
                    <div class="flex items-center" v-if="techTopic.length > 10" @click.stop="handleMore">
                        <span class="cursor-pointer text-primary">{{showMoreText}}</span>
                        <PtIcon class="action-icon cursor-pointer  fill-blue-500" :icon="showMoreIcon" />
                    </div>
                </div>

            </div>

            <div class="h-[548px] flex-1">
                <BIChart :key="activeTab"
                         ref="graphTechChart"
                         :chartType="chartType"
                         :chartKey="chartKey"
                         :isLoading="isFetchLoading"
                         :configTaskFunc="chartConfig"
                         :dataTaskFunc="getGraphChartData"
                         @visualReady="handleVisualReady"
                         @click="handleDrillDown"
                         class="h-full w-full" />

                <GraphTool key="RelationshipTech" :formattedZoom="formattedZoom" v-if="!graphTechChart?.isEmptyChart"/>
            </div>
        </div>

    </div>
</template>

<script setup lang="ts">
import '@patsnap-ui/icon/assets/VectorGradient.svg';
import '@patsnap-ui/icon/assets/solid/DoubleArrowDown.svg';
import '@patsnap-ui/icon/assets/solid/DoubleArrowUp.svg';
import { PtIcon } from 'patsnap-biz';
import BIChart from '@/components/BIChart.vue';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useTechGraph } from '@/composables/use-tech-graph';
import { useGraphTool } from '@/composables/use-graph-tool';
import GraphTool from '@/components/GraphTool.vue';

const { t } = useI18n();

const graphTechChart = ref<{
    generateChartImage: () => Promise<string>,
    drawChart: () => void,
    isChartLoaded: () => boolean
    clearSelect: () => void,
    isEmptyChart: boolean
}>();

const {
    topicId,
    tabs,
    activeTab,
    disableUI,
    chartType,
    chartKey,
    chartConfig,
    isFetchLoading,
    getGraphChartData,
    downloadChartAsImage,
    changeTab,
    handleTopic,
    techTopic,
    loadingTopic,
    handleDrillDown,
    handleMore,
    techTopicArray,
    showMoreText,
    showMoreIcon,
    isShowTechTopic,
    isLoadingAllTopic,
} = useTechGraph({ graphTechChart });

const { handleVisualReady, formattedZoom } = useGraphTool()

</script>
